import { i18n } from '@fs/zion-locale'

export default {
  columnsToShow: () => i18n.t('columnPicker.columnsToShow', 'Columns to Show in Results:'),
  contentToShow: () => i18n.t('columnPicker.contentToShow', 'Content to Show'),
  radioGeneralPublic: () => i18n.t('columnPicker.radioGeneralPublic', 'General Public'),
  radioInternalStaff: () => i18n.t('columnPicker.radioInternalStaff', 'Internal Staff'),
  romanizationOptionsCantonese: () => i18n.t('columnPicker.romanizationCantonese', 'Cantonese'),
  romanizationOptionsJyutping: () => i18n.t('columnPicker.romanizationJyutping', 'Jyutping'),
  romanizationOptionsKorean: () => i18n.t('columnPicker.romanizationKorean', 'Korean'),
  romanizationOptionsMandarin: () => i18n.t('columnPicker.romanizationMandarin', 'Mandarin'),
  romanizationOptionsPinYin: () => i18n.t('columnPicker.romanizationPinyin', 'Mandarin Pinyin'),
  romanizationOptionsWadegiles: () => i18n.t('columnPicker.romanizationWadegiles', 'Mandarin Wade-Giles'),
  romanizationOptionsYale: () => i18n.t('columnPicker.romanizationYale', 'Yale Romanization'),
  romanizationSelectLabel: () => i18n.t('columnPicker.romanizationSelectLabel', 'Select Romanization'),
  romanizationSelectPlaceholder: () => i18n.t('columnPicker.romanizationSelectPlaceholder', 'Choose a romanization...'),
  searchByMap: () => i18n.t('columnPicker.searchByMap', 'Search by Map'),
  showMap: () => i18n.t('columnPicker.showMap', 'Show map in Refine Search'),
  tooltipInternalOnly: () =>
    i18n.t('columnPicker.tooltipInternalOnly', 'Note: Items with the locked icon are only visible to internal staff.'),
  viewMode: () => i18n.t('columnPicker.viewMode', 'View Mode'),
  options: () => i18n.t('columnPicker.options', 'Options'),
  internalStaffOnlyMessage: () =>
    i18n.t(
      'columnPicker.internalStaffOnlyGrayMessage',
      'Items with a gray background are only shown to internal staff'
    ),
  staffOnly: () => i18n.t('columnPicker.staffOnly', 'Staff only'),
}
